var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[_c('headerCom'),_c('router-view'),_c('div',{staticClass:"ap-fromdiv position-fixed"}),_c('footerCom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }